<template>
    <div class="group-save">
        <el-dialog :modal="false" title="创建群组" :visible.sync="isShow" @close="cancel">
        <el-form :model="ruleForm" :rules="rules"  ref="ruleF" >
            <el-form-item prop="name">
                <div class="title">名称</div>
                <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="desc">
                <div class="title">描述</div>
                 <el-input type="textarea" resize="none" :rows="3" v-model="ruleForm.desc" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click.stop="confirm">确 定</el-button>
            <el-button @click.stop="cancel">取 消</el-button>
        </div>
        </el-dialog>
        <div class="cover"></div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      isShow: false,
      ruleForm: {
        name: '',
        desc: '',
        isShow: false
      },
      rules: {
        name: [
          { required: true, message: '请输入组名称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        desc: [
          { required: false, message: '请填写组描述', trigger: 'blur' }
        ]
      }
    }
  },
  props: ['dialogFormVisible'],
  inject: {
    all: {
      default: () => {}
    }
  },
  watch: {
    dialogFormVisible (newData) {
      this.isShow = newData
      if (this.all['index'] || this.all['index'] === 0) {
        this.ruleForm.name = this.all['name']
        this.ruleForm.desc = this.all['desc']
      }
    }
  },
  methods: {
    initData () {
      this.ruleForm.name = ''
      this.ruleForm.desc = ''
    },
    confirm () {
      this.$refs['ruleF'].validate((valid) => {
        if (valid) {
          this.isShow = false
          this.$emit('confirm', this.ruleForm)
        }
      })
    },
    cancel () {
      this.isShow = false
      this.$emit('cancel', this.ruleForm)
    }
  },
  mounted () {
    this.isShow = this.dialogFormVisible
    if (this.all['index'] || this.all['index'] === 0) {
      this.ruleForm.name = this.all['name']
      this.ruleForm.desc = this.all['desc']
    } else {
      this.initData()
    }
  }
}
</script>
<style lang="less" scoped>
.group-save {
    /deep/ .el-dialog__title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
    }
    .title {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #000000;
    }
    /deep/ .el-dialog__body{
        padding: 10px 24px;
    }
    /deep/ .el-form {
        .el-dialog {
            width: 43%
        }
        .el-form-item {
            margin-bottom: 10px;
        }
    }
   /deep/ .el-dialog__wrapper {
      z-index: 2005 !important;
    }
    .cover {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: .4;
      z-index: 2004;
    }
    // .el-form-item {
    //     display: flex;
    //     flex-flow: column nowrap;
    // }
}
</style>
